/**
 * Add Bonus Points Overlay
 *
 * This code defines a React component called AddBonusPoints that allows hosts to give bonus points to a particular team. 
 * The component renders a form with inputs for the team, point value, and description. 
 * When the form is submitted, the component sends a POST request to the server to add the bonus points. 
 * The component also handles errors and displays a loading spinner while the request is being processed. 
 * The component receives two props: user_id and team_options. The former is the ID of the host user, 
 * and the latter is an array of options for the team select input.
 */

import React from 'react'
import PropTypes from 'prop-types'
import HostContext from '../../utils/host-context'
import FloatingInput from '../floating-input'
import FloatingSelect from '../floating-select'
import SvgCirclePlus from '../svg/plus-circle'
import API from '../../utils/api'
import SVGLoader from '../svg/loader'

export default class AddBonusPoints extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      team_id: ``,
      value: ``,
      description: ``,
      loading: false,
      errors: false,
    }
    this.handleUpdate = this.handleUpdate.bind(this)
    this.handleAddPoints = this.handleAddPoints.bind(this)
    this.updateTeamID = this.updateTeamID.bind(this)
  }

  handleUpdate(event) {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  updateTeamID(event) {
    this.setState({
      [event.target.name]: event.target.value,
    })
    this.setTeamID(event.target.value)
  }

  handleAddPoints(event) {
    event.preventDefault()
    this.setState({ loading: true })
    let post_data = {
      host: this.props.user_id,
      team: this.team_id,
      value: this.state.value,
      description: this.state.description,
    }
    var self = this
    API.post(`/host/scoring/`, post_data, {
      headers: {
        Authorization: `JWT ${localStorage.getItem(`token`)}`,
      },
    })
      .then(res => {
        console.log(res)

        // clean inputs and close?
        this.setState(
          {
            value: ``,
            description: ``,
            team_id: ``,
            loading: false,
            errors: false,
          },
          this.toggleBonusPoints
        )
      })
      .catch(function(error) {
        console.log(error)
        self.setState({
          loading: false,
          errors: `There was a problem adding bonus points. Please check your input and try again.`,
        })
      })
  }

  render() {
    const { team_options } = this.props
    const { loading, errors } = this.state
    return (
      <HostContext.Consumer>
        {({ toggleBonusPoints, team_id, setTeamID }) => {
          this.toggleBonusPoints = toggleBonusPoints
          this.setTeamID = setTeamID
          this.team_id = team_id
          return (
            <div className={`site-menu-points`} role="navigation">
              <button className={`btn btn-block btn-success`} onClick={toggleBonusPoints}>
                Bonus Points <SvgCirclePlus />
              </button>

              <form
                className={`form px-4 py-4 mx-4 my-5`}
                style={{
                  backgroundColor: `rgba(238,234,225,0.60)`,
                }}
                onSubmit={this.handleAddPoints}>
                <FloatingSelect
                  name={`team_id`}
                  placeholder={`Team`}
                  onChange={this.updateTeamID}
                  value={team_id}
                  options={team_options}
                />
                <FloatingInput
                  name={`value`}
                  placeholder={`Point Value`}
                  onChange={this.handleUpdate}
                  value={this.state.value}
                />
                <FloatingInput
                  name={`description`}
                  placeholder={`Description`}
                  onChange={this.handleUpdate}
                  value={this.state.description}
                />
                {errors && <p className="incorrect text-danger">{errors}</p>}
                {loading ? (
                  <div className={`text-center`}>
                    <SVGLoader />
                  </div>
                ) : (
                  <input className={`btn btn-secondary btn-block mb-3`} type="submit" value="Add Points" />
                )}
              </form>
              <button className={`btn btn-block btn-tiny text-primary`} onClick={toggleBonusPoints}>
                Cancel
              </button>
            </div>
          )
        }}
      </HostContext.Consumer>
    )
  }
}

AddBonusPoints.propTypes = {
  user_id: PropTypes.number.isRequired,
  team_options: PropTypes.array.isRequired,
}